<template>
    <div class="view view__session_iframe_bookingform">
        <session-iframe-bookingform/>
    </div>
</template>

<script>
import { User } from '@/User'
import SessionIframeBookingform from '@/components/ebs/sessions/iframe/SessionIframeBookingForm'

export default {
  components: { SessionIframeBookingform },
  name: 'view-session-iframe-bookingform',
  data () {
    return {
      user: new User()
    }
  },
  computed: {
    sessionId: function () {
      return this.$store.getters.getSessionId
    },
    sessionEventId: function () {
      return this.$store.getters.getEventId
    }
  },
  watch: {
    sessionId: function () {
      if (this.sessionId && this.sessionEventId) {
        this.$eventBus.$emit('stop-loading')
      }
    },
    sessionEventId: function () {
      if (this.sessionId && this.sessionEventId) {
        this.$eventBus.$emit('stop-loading')
      }
    }
  },
  methods: {
    getSession: function () {
      this.$eventBus.$emit('start-loading')
      const sessionID = this.$route.params.sessionId
      this.$store.dispatch('getSession', sessionID)
    },
    getSessionEvent: function () {
      this.$eventBus.$emit('start-loading')
      const eventID = this.$route.params.eventId
      this.$store.dispatch('getEvent', eventID)
    }
  },
  created () {
    this.getSession()
    this.getSessionEvent()
  }
}
</script>
